import { Box, Grid } from "@mui/material";
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../../components/common/FormikControl";
import { useSelector } from "react-redux";
import { selectAllRoles } from "../../../../slices/roles";

const Filter = ({ onApply, onClear, initialFilters }) => {
    const allRoles = useSelector(selectAllRoles)
    const initialValues = {
        role_id: [],
        ...initialFilters
    }

    const formOptions = [
        {
            label: 'Role Type',
            type: 'select',
            multiple: true,
            name: 'role_id',
            inputClassName :  'multi-select-field',
            options: allRoles.map(op => { return { value: op.id, label: op.title } })
        },
    ]


    const handleSubmit = (values) => {
        onApply(values);
    }

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: handleSubmit
    })

    const handleClear = () => {
        formik.resetForm();
        onClear();
    };

    return (
        <Box>
            <form onSubmit={formik.handleSubmit}>
                {formOptions.map((props, key) => (
                    <Grid key={key} item xs={12}>
                        <FormikControl formik={formik} {...props} />
                    </Grid>
                ))}

                <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2, marginTop: "10px" }}>
                    <LoadingButton size="large" sx={{ borderRadius: "6px" }} onClick={handleClear} variant="outlined">Clear Filter</LoadingButton>
                    <LoadingButton size="large" sx={{ borderRadius: "6px" }} type="submit" variant="contained">Apply Filter</LoadingButton>
                </Box>
            </form>
        </Box>
    );
}

export default Filter;